module.exports = __webpack_public_path__ + "logo_transparent-73bf4bea5ad08ce44d516e472dc452c1.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/mailer/logo_transparent.png
// module id = 280
// module chunks = 88